// Core
import styled from 'styled-components';

export const Element = styled.div`
  width: 100%;
  height: 100%;

  > div > div {
    width: 100% !important;
    height: 100% !important;

    > div {
      width: 100% !important;
      height: 100% !important;
    };
  };
`;
